import { graphql } from '../../__generated__';

export const PORTFOLIO_MARKET_VALUE_DATA = graphql(`
  query InventoriesByDatetimeRange($dateFrom: String, $dateTo: String) {
    inventoriesByDatetimeRange(dateFrom: $dateFrom, dateTo: $dateTo)
  }
`);
